import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { id: "create-users" }
const _hoisted_2 = { class: "double" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sobrenome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_5 = { class: "double" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "E-mail"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nível do usuário"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = { class: "spacing" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_13 = {
  class: "stats",
  for: "stats"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = ["disabled"]

import { computed, onMounted, ref } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import MySelectFilter from '@/components/select/MySelectFilter.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import RoleModel from '@/models/RoleModel'
import { UserModel } from '@/models/UserModel'
import { OrganizationModel } from '@/models/OrganizationModel'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { toast } from 'vue3-toastify'
import { user } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateUsersView',
  setup(__props) {

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const payload = ref<Partial<UserModel>>({ roles: [], password: '' })
const roles = ref<RoleModel[]>()
const organizationsInitial = ref<OrganizationModel[]>()
const documentFiles = ref<File[]>([])
const isCreatingUser = ref(false)
const orgSearch = ref('')
const organizations = computed(() => {
  return organizationsInitial.value?.filter(organization =>
    organization.name.toLowerCase().includes(orgSearch.value.toLowerCase()) || !orgSearch.value
  )
})
const allowedRoles = computed(() => {
  return roles.value?.filter((role) => role.name == 'Super Admin' || role.name == 'Presidente' ? user.value?.hasRoles!(['Super Admin']) || user.value?.hasRoles!(['Presidente']) : true)
})

const verifyValueOrganization = (value: string) => {
  if (organizations.value) {
    let onClear = false
    for (const [index, options] of organizationsInitial.value!.entries()) {
      if (options.name === value) {
        onClear = true
      }
    }
    if (!onClear) {
      orgSearch.value = ''
      payload.value.organization = undefined
    }
  }
}

function getRoles (): void {
  axios.get('/api/roles')
    .then((res: AxiosResponse<RoleModel[]>) => {
      roles.value = res.data
    })
}

function getOrganizations (): void {
  axios.get('/api/organizations')
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizationsInitial.value = res.data
    })
}

function createUser (): void {
  isCreatingUser.value = true

  const formData = new FormData()
  for (const key in payload.value) {
    if (payload.value[key]) {
      if (key == 'roles') {
        formData.append('roles[0]', payload.value.roles![0].name as string)
      } else if (key == 'image') {
        formData.append(key, payload.value[key] as string)
      } else if (key == 'status') {
        formData.append(key, payload.value[key] ? '1' : '0')
      } else {
        formData.append(key, String(payload.value[key]))
      }
    }
  }
  formData.append('organization_id', String(payload.value.organization!.id))

  axios.post('/api/users', formData)
    .then(() => {
      toast.success('Usuário criado com sucesso')
      payload.value = { roles: [], password: '' }
    })
    .finally(() => isCreatingUser.value = false)
}

onMounted(() => {
  getRoles()
  getOrganizations()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Ex: João",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event))
        }, null, 512), [
          [_vModelText, payload.value.name]
        ])
      ]),
      _createElementVNode("section", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Ex: da Silva",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.last_name) = $event))
        }, null, 512), [
          [_vModelText, payload.value.last_name]
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("section", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Ex: João@gmail.com",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.email) = $event))
        }, null, 512), [
          [_vModelText, payload.value.email]
        ])
      ]),
      _createElementVNode("section", null, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Pelo menos 6 caracteres",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.password) = $event))
        }, null, 512), [
          [_vModelText, payload.value.password]
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _hoisted_8,
      (roles.value)
        ? (_openBlock(), _createBlock(MySelect, {
            key: 0,
            name: 'role',
            for: 'role',
            currentValue: payload.value.roles?.length ? payload.value.roles[0].name : null
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedRoles.value, (role, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onMousedown: ($event: any) => {payload.value.roles![0] = role;}
                }, _toDisplayString(role.name), 41, _hoisted_9))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h1", null, [
        _createElementVNode("strong", null, "A qual " + _toDisplayString(isChamber.value ? 'câmara' : 'setor') + " pertence", 1),
        _createTextVNode(" (obrigatório)")
      ]),
      (organizations.value)
        ? (_openBlock(), _createBlock(MySelectFilter, {
            key: 0,
            name: 'organization',
            value: orgSearch.value,
            modelValue: orgSearch.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orgSearch).value = $event)),
            onBlur: verifyValueOrganization
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onMousedown: ($event: any) => {payload.value.organization = organization; orgSearch.value = organization.name}
                }, _toDisplayString(organization.name), 41, _hoisted_10))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "modelValue"]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
    ]),
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("label", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "stats",
          id: "stats",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.status) = $event))
        }, null, 512), [
          [_vModelCheckbox, payload.value.status]
        ]),
        _hoisted_14
      ])
    ]),
    _createElementVNode("nav", null, [
      (!isCreatingUser.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            value: "Criar",
            disabled: !payload.value.name || !payload.value.last_name || !payload.value.email || payload.value.password!.length < 6 || !payload.value.roles!.length || !payload.value.organization,
            onClick: createUser
          }, null, 8, _hoisted_15))
        : (_openBlock(), _createBlock(SpinnerLoaderButton, {
            key: 1,
            height: 60,
            maxWidth: 464
          })),
      _createElementVNode("input", {
        type: "button",
        value: "Cancelar",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.go(-1)))
      })
    ])
  ]))
}
}

})